import { Stack, Typography } from "@mui/material";

import { Info } from 'lucide-react';

export default function CommonInformation({ info = null }) {
  return (
    <Stack
      direction="row"
      spacing={0.75}
      alignItems="center"
      sx={{
        position: "relative",
        color: '#7b8494',
        p: "1rem 1rem 1rem 1rem"
      }}
    >
      <Info size={".8rem"} />

      <Typography
        variant="caption"
        sx={{
          fontSize: ".8rem",
        }}
      >
        {info ?? "Dados referentes ao período selecionado"}
      </Typography>
    </Stack>
  )
}